
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="addForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="discipline_id">Discipline</label>
    <div class="col-8">
<!--      <input type="text" id="subscale_description" formControlName="subscale_description" class="form-control" appAutoFocus>-->
      <kendo-dropdownlist id="discipline_id" formControlName="discipline_id"
                          [data]="disciplines" [valuePrimitive]="true" textField="discipline_name" valueField="id"
                          [defaultItem]="{ id: null, discipline_name: 'Select...' }" appAutoFocus>
      </kendo-dropdownlist>
      <div *ngIf="discipline_id?.invalid" class="alert alert-danger">
        <div *ngIf="discipline_id?.errors?.['required']">Discipline  required.</div>
      </div>
    </div>
  </div>


</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="addForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>

